<template>
  <div>
    <div class="flex flex-col w-full relative">
      <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
      <div v-if="pictogram == null">
        <ProgressOverview
          :pictograms="pictograms"
          :company-alias="company.alias"
          :img-plant="imgPlant"
          :is-loading-image="isLoadingImage"
          @image-load="onImageLoad"
          @image-error="onImageError"
          @show-image-plant="_ShowImagePlant"
          @select-pictogram="_HandleClickSelectPictogram"
          @force-refresh="_HandleForceRefresh"
          @go-back="$emit('go-back')"
        />
      </div>
      <div v-else>
        <ProgressDetail
          :pictogram="pictogram"
          :company-alias="company.alias"
          :img-pictogram="imgPictogram"
          :is-loading-image="isLoadingImage"
          :ratios="ratios"
          :validation-times="validationTimes"
          @image-load="onImageLoad"
          @image-error="onImageError"
          @show-image="_ShowImage"
          @go-back="_HandleGoBack"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import EventBus from "~/plugins/bus";
import ProgressOverview from "./dashboard/ProgressOverview.vue";
import ProgressDetail from "./dashboard/ProgressDetail.vue";

export default {
  name: "manage-photovoltaic-park",

  components: {
    ProgressOverview,
    ProgressDetail,
  },

  data: () => ({
    pictograms: [],
    pictogram: null,
    isLoading: false,
    isLoadingImage: false,

    imgPictogram: {
      src: null,
      extension: null,
      type: null
    },

    powerPlant: null,
    imgPlant: {
      src: null,
      extension: null,
      type: null,
      updatedAt: null,
    },

    ratios: {},
    validationTimes: [],
  }),

  props: {
    projectId: { type: Number, required: true },
    showDownloadFileOriginal: { type: Boolean, default: true },
    permittedActions: { type:Object, default() { return {} } },
    canActionsPictogram: { type:Object, default() { return {} } }
  },

  computed: {
    ...mapGetters({
      company: "app/company",
    }),
  },

  watch: {
    pictogram(newVal) {
      if (newVal !== null && this.company.alias === 'solaring') {
        this.getRatioPictograms();
        this.getValidationTimes();
      }
    }
  },

  created() {
    EventBus.$on('refreshPictogramScreenshot', this._OnScreenshotUpdated);
    this.getProjectPictograms();
  },

  beforeDestroy() {
    EventBus.$off('refreshPictogramScreenshot', this._OnScreenshotUpdated);
  },

  methods: {
    _OnScreenshotUpdated(e) {
      if (e.entity === 'power-plant' && this.powerPlant?.id === e.entity_id) {
        // refrescar imgPlant.updatedAt + cache-bust si layer activo coincide
        // Sincronizar metadata local
        if (!this.powerPlant.metadata) this.powerPlant.metadata = {}
        if (!this.powerPlant.metadata.screenshots) this.powerPlant.metadata.screenshots = {}
        this.powerPlant.metadata.screenshots[e.layer] = { last_update: e.last_update }

        // Solo refrescar si la capa activa coincide
        if (this.imgPlant.type === e.layer && this.imgPlant.src) {
          this.imgPlant.updatedAt = e.last_update
          this.isLoadingImage = true
          const url = new URL(this.imgPlant.src)
          url.searchParams.set('v', Date.now())
          this.imgPlant.src = url.href
        }
        // this._HandleForceRefresh();
      } else if (e.entity === 'pictogram' && this.pictogram?.id === e.entity_id) {
        // mismo patrón con imgPictogram
      }
    },

    async getRatioPictograms() {
      if (!this.pictogram) {
        return;
      }

      try {
        this.isLoading = true;
        let params = {
          with_ratios: 1
        };

        const { data } = await axios.get(
          `/api/v2/pictogram/${this.pictogram.id}/ratios`,
          { params: params }
        );
        if (data && data.success) {
          if (data.ratios) {
            this.ratios = data.ratios
          }
        } else {
          this.$notify.error("error_loading_documents");
        }
      } catch (error) {
        this.$notify.error("error_loading_documents");
      } finally {
        this.isLoading = false;
      }
    },

    async getValidationTimes() {
      if (!this.pictogram) {
        return;
      }

      try {
        this.isLoading = true;

        const { data } = await axios.get(
          `/api/v2/pictogram/${this.pictogram.id}/validation-times`
        );

        if (data && data.success) {
          if (data.validation_times) {
            this.validationTimes = data.validation_times;
          }
        } else {
          this.$notify.error("error_loading_data");
        }
      } catch (error) {
        this.$notify.error("error_loading_data");
      } finally {
        this.isLoading = false;
      }
    },

    async getProjectPictograms() {
      this.isLoading = true;
      let params = {
        with_screenshot: 1,
        with_associated_activity: 1,
        with_power_plant: 1
      };

      const { data } = await axios.get(
        "/api/v2/project/" + this.projectId + "/pictograms",
        { params: params }
      );

      if (data && data.success) {
        this.pictograms = data.pictograms.filter((el) => {
          return el.activity_planning_code && ! el.activity_planning_code.includes('.R.')
        });

        this.powerPlant = data.powerPlant

        if(data.powerPlant) {
          this.isLoadingImage = true

          // TODO: aqui falta condision en caso de que screenshot sea null
          this.imgPlant.src = data.powerPlant.screenshot + '?v=' + new Date().getTime()
          this.imgPlant.extension = data.powerPlant.screenshot.split('.').pop()
          let tmp = data.powerPlant.screenshot.split('_')
          this.imgPlant.type = tmp[tmp.length - 1].split('.').shift()

          // Timestamp de la última actualización del screenshot del layer activo
          const screenshots = (data.powerPlant.metadata && data.powerPlant.metadata.screenshots) || {}
          this.imgPlant.updatedAt = (screenshots[this.imgPlant.type] && screenshots[this.imgPlant.type].last_update) || null
        }

        this.total = data.pictograms ? data.pictograms.length : 0;
      } else {
        this.$notify.error("error_loading_documents");
      }
      this.isLoading = false;
    },

    _ShowImage(type) {
      if (this.pictogram != null && this.pictogram.screenshot != null) {
        this.isLoadingImage = true
        this.imgPictogram.src = this.imgPictogram.src.replace('_' + this.imgPictogram.type + '.' + this.imgPictogram.extension, '_' + type + '.' + this.imgPictogram.extension)

        let url = new URL(this.imgPictogram.src)
        url.searchParams.delete('v')
        this.imgPictogram.src = url.href

        this.imgPictogram.src += '?v=' + new Date().getTime()
        this.imgPictogram.type = type
      }
    },

    _ShowImagePlant(type) {
      if (this.powerPlant != null && this.powerPlant.screenshot != null) {
        this.isLoadingImage = true
        this.imgPlant.src = this.imgPlant.src.replace('_' + this.imgPlant.type + '.' + this.imgPlant.extension, '_' + type + '.' + this.imgPlant.extension)

        let url = new URL(this.imgPlant.src)
        url.searchParams.delete('v')
        this.imgPlant.src = url.href

        this.imgPlant.src += '?v=' + new Date().getTime()
        this.imgPlant.type = type

        // Timestamp del layer al que se cambia
        const screenshots = (this.powerPlant.metadata && this.powerPlant.metadata.screenshots) || {}
        this.imgPlant.updatedAt = (screenshots[type] && screenshots[type].last_update) || null
      }
    },

    async _HandleForceRefresh() {
      // Re-fetch para que tanto la imagen como el timestamp queden al día.
      await this.getProjectPictograms()
    },

    _HandleClickSelectPictogram(item) {
      this.isLoadingImage = true
      this.pictogram = item

      if (this.pictogram.screenshot != null) {
        this.imgPictogram.src = item.screenshot + '?v=' + new Date().getTime()
        this.imgPictogram.extension = item.screenshot.split('.').pop()
        let tmp = item.screenshot.split('_')
        this.imgPictogram.type = tmp[tmp.length - 1].split('.').shift()
      }
    },

    _HandleGoBack() {
      this.isLoadingImage = false;
      this.pictogram = null;
      this.imgPictogram.src = null;
      this.imgPictogram.extension = null;
      this.imgPictogram.type = null;
    },

    onImageLoad() {
      this.isLoadingImage = false;
    },
    onImageError() {
      this.isLoadingImage = false;
      console.error('Error al cargar la imagen');
    }
  }

};
</script>

<style scoped>
</style>
